// src/api/axios.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL
;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  // timeout: 10000,
});

// Attach token automatically to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 (Unauthorized) — remove token and broadcast an event so the rest of the app can react.
// Don't redirect here; let the app decide how to navigate (client-side).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    try {
      const status = error.response?.status;
      const reqUrl = error.config?.url || "";

      if (status === 401) {
        // treat auth endpoints as allowed to fail without broadcasting logout
        const isAuthEndpoint =
          reqUrl.includes("/auth/login") ||
          reqUrl.includes("/auth/register") ||
          reqUrl.includes("/auth/refresh");

        if (!isAuthEndpoint) {
          // remove token locally (so other tabs see storage change)
          localStorage.removeItem("token");

          // dispatch a global event that the app listens to
          window.dispatchEvent(
            new CustomEvent("auth:logout", { detail: { reason: "unauthorized" } })
          );
        }
        // inside api.interceptors.response error handler
if (status === 401 && !isAuthEndpoint) {
  localStorage.removeItem("token");
  localStorage.removeItem("user"); // defensive
  window.dispatchEvent(new CustomEvent("auth:logout", { detail: { reason: "unauthorized" } }));
}

      }
      
    } catch (e) {
      // ignore
    }

    return Promise.reject(error);
  }
);

export default api;
